import React, { useState, useEffect } from "react";
import {
  Container,
  Background,
  Hr,
  Titulo,
  Button,
  Input,
  Row,
  Table,
} from "./style";
import api from "../../../services/api";
import { Swal, Toast } from "../../../services/SwalTemplates";
import Pagination from "../../../components/Pagination";
import ModalRegister from "../../../components/Modal/Rh/Projetos/Register";
import ModalEdit from "../../../components/Modal/Rh/Projetos/Edit";
import { IoPencilOutline, IoTrashOutline } from "react-icons/io5";
import { isAuthenticatedDiretor, isAuthenticatedSecretaria } from "../../../auth";

export default function Projetos() {
  const [filtro, setFiltro] = useState("");
  const [showModalRegister, setShowModalRegister] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [projetos, setProjetos] = useState([]);
  const [projeto, setProjeto] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const diretor = isAuthenticatedDiretor();
  const secretaria = isAuthenticatedSecretaria();
  useEffect(() => {
    api
      .get(`/rh/projects?nome=${filtro}`)
      .then((response) => {
        setProjetos(response.data.projetos);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [filtro]);

  useEffect(() => {
    setTotalPages(Math.ceil(projetos.length / 15));
  }, [projetos]);

  function handleDelete(id) {
    Swal.fire({
      title: "Você tem certeza?",
      text: "Você não poderá reverter essa ação!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Deletar",
      cancelButtonColor: "gray",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await api.delete(`/rh/projects/${id}`);
        if (response.data.error) {
          return Swal.fire(
            "Exclusão não permitida!",
            response.data.error,
            "warning"
          );
        }
        Toast.fire({
          icon: "success",
          title: "Deletado com sucesso!",
        });
        setProjetos(
          projetos.filter((projeto) => projeto.id !== id)
        );
      }
    });
  }

  return (
    <Background>
      <Container>
        <Titulo>Controle de Projetos</Titulo>
        <Hr />
        <Row>
          <Button
            hidden={diretor || secretaria}
            onClick={() => {
              setShowModalRegister(true);
            }}
          >
            Novo
          </Button>
          <Input>
            <input
              type="text"
              placeholder="Pesquisar projeto..."
              value={filtro}
              onChange={(e) => {
                setFiltro(e.target.value.toUpperCase());
                setPage(1);
              }}
            />
          </Input>
        </Row>
        <Table>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Ativo</th>
                <th hidden={diretor || secretaria}></th>
                <th hidden={diretor || secretaria}></th>
              </tr>
            </thead>
            <tbody>
              {projetos.slice((page - 1) * 15, page * 15).map((d, i) => (
                <tr key={i}>
                  <td data-title="ID" value={d.id}>
                    {d.id}
                  </td>
                  <td data-title="Nome" value={d.nome} className="td-left">
                    {d.nome.toUpperCase()}
                  </td>
                  <td data-title="Ativo" value={d.ativo}>
                    {d.ativo === 1 ? "Sim" : "Não"}
                  </td>
                  <td data-title="Editar" hidden={diretor || secretaria}>
                    <IoPencilOutline
                      title="Editar"
                      style={{ fontSize: "25px", cursor: "pointer" }}
                      onClick={() => {
                        setProjeto(d);
                        setShowModalEdit(true);
                      }}
                    />
                  </td>
                  <td data-title="Excluir" hidden={diretor || secretaria}>
                    <IoTrashOutline
                      title="Excluir"
                      style={{ fontSize: "25px", cursor: "pointer" }}
                      onClick={() => {
                        handleDelete(d.id);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Table>
        <ModalRegister
          showModal={showModalRegister}
          setShowModal={setShowModalRegister}
        />
        <ModalEdit
          showModal={showModalEdit}
          setShowModal={setShowModalEdit}
          data={projeto}
        />
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </Container>
    </Background>
  );
}
